import {
  BaseFieldWidget,
  BaseTableFieldWidget,
  ModelFieldType,
  RowContext,
  SPI,
  ViewType,
  Widget
} from '@kunlun/dependencies';
import { VNode } from 'vue';

/**
 * 评估规则配置列表 - 「评估指标数」计算列
 *
 * <p>读取行内 indicators（OneToMany）数组长度，渲染为「N项」。</p>
 *
 * <p>绑定字段：DeliAriesPlatformEvaluationRule.indicators。
 * 复用默认 O2M 表格列 widget 名 'Table' + 字段名精确覆盖（不约束 model，避免代理/继承导致不匹配）。</p>
 */
@SPI.ClassFactory(
  BaseFieldWidget.Token({
    viewType: ViewType.Table,
    ttype: ModelFieldType.OneToMany,
    widget: 'Table',
    name: 'indicators'
  })
)
export class TableIndicatorCountFieldWidget extends BaseTableFieldWidget {
  @Widget.Method()
  public renderDefaultSlot(context: RowContext): VNode[] | string {
    const value = this.compute(context) as unknown[];
    const count = Array.isArray(value) ? value.length : 0;
    return `${count}项`;
  }
}
